import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Logger } from "../logger.service";

const log = new Logger('ApiService');

@Injectable({
  providedIn: 'root'
})
export abstract class BaseApiService {

  constructor(protected httpClient: HttpClient) {
  }

  protected handleError<T>(operation = 'operation', result?: T | null) {
    return (error: any): Observable<T> => {
      log.error(error); // log to console instead
      log.error(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}